import React from 'react';
import { Alert } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setSnackbar } from 'redux/features/ui-slice';
import StyledMuiSnackbar from 'views/rebranded-module/common/components/Logical/SnackBarV2/SnackBarV2.styles';

const SnackBarV2 = () => {
  const dispatch = useDispatch();
  const {
    message, open, severity, duration, messageComponent,
  } = useSelector(
    (state) => state.ui.snackbar,
  );
  const handleSnackbarClose = () => {
    dispatch(
      setSnackbar({
        open: false,
      }),
    );
  };
  return (
    <StyledMuiSnackbar
      open={open}
      autoHideDuration={duration}
      onClose={handleSnackbarClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}>
      <Alert
        className="SBAlert"
        elevation={0}
        variant="filled"
        onClose={handleSnackbarClose}
        severity={severity}>
        {message ? (
          <span dangerouslySetInnerHTML={{ __html: message }} />
        ) : (
          <span>{messageComponent}</span>
        )}
      </Alert>
    </StyledMuiSnackbar>
  );
};

export { SnackBarV2 };
